
import classnames from 'classnames';
import styles from './Service.module.css';
import Icon from '../../design-system/General/Icon';

export default function ServiceSection({title, text, services, sectionRef}) {
    return (
      <section className={styles['service-section']} ref={sectionRef}>
        <div className="container-lg">
          <div className="row">
            <div className="col-12 col-sm-11 col-lg-10 mx-auto">
              <div className={styles['service-section_head']}>
                <h2 className={styles['service-section_title']}>{title}</h2>
                <p className={styles['service-section_text']}>{text}</p>
              </div>

              <div className="row service-row">
                {services.length > 0 && services.map(s => (
                  <div className="col-10 col-sm-6 col-md-4">
                    <div className={classnames(styles['service-card'], 'position-relative')}>
                      <div className={styles['service-card_inner']}>
                        {s.icon && 
                          <div className={styles['service-card_thumb']}>
                            <i className={s.icon}></i>
                          </div>
                        }
                        <h3 className={styles['service-card_title']}>
                          <a href={s.src_link} className={classnames(styles['service-card_link'], 'stretched-link')}>
                            {s.src_title}
                          </a>
                        </h3>
                      </div>
                      <div className={styles['service-card_btn_circle']}>
                        <a href={s.src_link} className={styles['service-card_btn']}>
                          <Icon name="icon-arrow-left" />
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            
          </div>
        </div>
      </section>
    );
}